export default "__VITE_ASSET__CZyJ3OgQ__"